// extracted by mini-css-extract-plugin
module.exports = {"container":"_50cec473","text":"_8d4a1ee9","tooltipText":"_35488e3c"};